import React from 'react'
import ClickAwayListener from 'react-click-away-listener'
import Cross from '../../images/ic_cross_with_white_bg'
import './popup.scss'

const Popup = ({
  children = null,
  className = '',
  hidePopup,
  popupId,
  closeOnClickOutside = true,
  hideCloseIcon = false,
  closeIcon
}) => {

  const handleClickAway = e => {
    if (closeOnClickOutside) {
      hidePopup(popupId, { onClickAway: true })
    }
  }
  return (
    <div className={`popup-overlay ${className}`}>
      <ClickAwayListener onClickAway={handleClickAway}>
        <div className={'popup'}>
          {hideCloseIcon ? '' :
            <div className="close-icon" onClick={() => {
              hidePopup(popupId)
            }}>
              {closeIcon || <Cross />}
            </div>}
          {children}
        </div>
      </ClickAwayListener>
    </div>
  )
}

export default Popup
